import React from "react";
import { Button, DialogActions, DialogContent } from "@mui/material";
import { Modal } from "components/haven-design";
import { getPropertyUseCases_getActiveSubaccounts as Subaccounts, getPropertyUseCases_property as Property } from "types/gql-types";
import UseCaseForm, { PropertyUseCaseType, UseCaseType } from "./use-case-form";

const emptyValues = {
  messageId: "",
  smsPrefix: "",
  applicationId: "",
  active: true,
};

const UseCaseModal:React.FC<{
  onSubmit: (item:PropertyUseCaseType) => void,
  useCases: UseCaseType[],
  subaccounts: Subaccounts[],
  property: Property,
  editItem: PropertyUseCaseType | null,
  open: boolean,
  onClose: () => void,
}> = ({
  open,
  onSubmit,
  onClose,
  useCases,
  subaccounts,
  property: { id: propertyId, name: propertyName },
  editItem,
}) => (
  <Modal
    isOpen={open}
    onRequestClose={onClose}
    title={`${editItem ? "Edit" : "Add"} Use Case - ${propertyName}`}
    fullScreen
  >
    <DialogContent>
      <UseCaseForm
        id={`use-case-form-${editItem ? "edit" : "add"}`}
        initialValues={editItem || {
          ...emptyValues,
          propertyId,
        } as PropertyUseCaseType}
        onSubmit={onSubmit}
        useCases={useCases}
        subaccounts={subaccounts}
      />
    </DialogContent>
    <DialogActions>
      <Button size="large" color="secondary" variant="outlined" onClick={onClose}>
          Cancel
      </Button>
      <Button
        size="large"
        color="primary"
        variant="contained"
        type="submit"
        form={`use-case-form-${editItem ? "edit" : "add"}`}
      >
        {editItem ? "Save" : "Add Use Case"}
      </Button>
    </DialogActions>
  </Modal>
);

export default UseCaseModal;
